import './App.css';
import React, { useState, useEffect } from "react";
import Axios from 'axios';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

//import Cors from 'cors'

function changeColor(colorParam, id) {
  var color
  if (colorParam)
    color = colorParam.toLowerCase();
  else
    color = "white";
  if (color === "green") {
    color = "#4CAF50";
  }
  else if (color === "select status") {
    color = "white";
  }
  var optionElement = document.getElementById(id);
  optionElement.style.background = color;
  optionElement.value = colorParam;
}

function updateAllStatusColor(res) {
  res ? changeColor(res.data.projectRisk, 'projectRisk') : changeColor("Select status", 'projectRisk');
  res ? changeColor(res.data.projectOverall, 'projectOverall') : changeColor("Select status", 'projectOverall');
  res ? changeColor(res.data.projectBudget, 'projectBudget') : changeColor("Select status", 'projectBudget');
  res ? changeColor(res.data.projectSchedule, 'projectSchedule') : changeColor("Select status", 'projectSchedule');
  res ? changeColor(res.data.projectScope, 'projectScope') : changeColor("Select status", 'projectScope');
  res ? changeColor(res.data.projectHumanResources, 'projectHumanResources') : changeColor("Select status", 'projectHumanResources');
  res ? changeColor(res.data.projectStakeholderEngagement, 'projectStakeholderEngagement') : changeColor("Select status", 'projectStakeholderEngagement');
}


function App() {

  const [selectState, setSelectState] = useState({ disabled: false })
  const [projectCodes, setProjectCodes] = useState("")

  const [projectCode, setProjectCode] = useState("")
  const [projectTitle, setProjectTitle] = useState("")
  const [reportee, setReportee] = useState("")
  const [projectOverall, setProjectOverall] = useState("")
  const [projectBudget, setProjectBudget] = useState("")
  const [projectSchedule, setProjectSchedule] = useState("")
  const [projectScope, setProjectScope] = useState("")
  const [projectHumanResources, setProjectHumanResources] = useState("")
  const [projectStakeholderEngagement, setProjectStakeholderEngagement] = useState("")
  const [projectRisk, setProjectRisk] = useState("")
  const [projectOverallComment, setProjectOverallComment] = useState("")
  const [projectBudgetComment, setProjectBudgetComment] = useState("")
  const [projectScheduleComment, setProjectScheduleComment] = useState("")
  const [projectScopeComment, setProjectScopeComment] = useState("")
  const [projectHumanResourcesComment, setProjectHumanResourcesComment] = useState("")
  const [projectStakeholderEngagementComment, setProjectStakeholderEngagementComment] = useState("")
  const [projectRiskComment, setProjectRiskComment] = useState("")

  var submittedDateTime = new Date();

  const submitChange = () => {
    submittedDateTime = new Date();
    //Check for whether projectCode is empty
    if (projectCode === "") { alert("Select a project Code") }
    else {
      //Set target http API entry and load up with payload
      // http://localhost:3001/api/insert
      // http://localhost:7071/api/insert
      // https://updateprojectdetail.azurewebsites.net/api/insert
      Axios.post('https://updateprojectdetail.azurewebsites.net/api/insert', {
        submittedDateTime: submittedDateTime.toISOString().slice(0, 19).replace('T', ' '),
        projectCode: projectCode,
        projectTitle: projectTitle,
        reportee: reportee,
        projectOverall: projectOverall,
        projectBudget: projectBudget,
        projectSchedule: projectSchedule,
        projectScope: projectScope,
        projectHumanResources: projectHumanResources,
        projectStakeholderEngagement: projectStakeholderEngagement,
        projectRisk: projectRisk,
        projectOverallComment: projectOverallComment,
        projectBudgetComment: projectBudgetComment,
        projectScheduleComment: projectScheduleComment,
        projectScopeComment: projectScopeComment,
        projectHumanResourcesComment: projectHumanResourcesComment,
        projectStakeholderEngagementComment: projectStakeholderEngagementComment,
        projectRiskComment: projectRiskComment

      }).then(() => {
        alert("Project Status Updated")
      });
    }
  };

  const requestLatest = () => {

    //https://updateprojectdetail.azurewebsites.net/api/insert
    Axios.post('https://updateprojectdetail.azurewebsites.net/api/requestLatest', {
      projectCode: projectCode
    }).then((res, err) => {
      if (err)
        console.log(err)
      else {
        console.log("Prefilling data");
        console.log("Project Code is " + projectCode)
        console.log(res.data)
        res.data.projectTitle ? setProjectTitle(res.data.projectTitle) : setProjectTitle("");
        res.data.reportee ? setReportee(res.data.reportee) : setReportee("");

        res.data.projectOverall ? setProjectOverall(res.data.projectOverall) : setProjectOverall("");
        res.data.projectOverallComment ? setProjectOverallComment(res.data.projectOverallComment) : setProjectOverallComment("");

        res.data.projectBudget ? setProjectBudget(res.data.projectBudget) : setProjectBudget("");
        res.data.projectBudgetComment ? setProjectBudgetComment(res.data.projectBudgetComment) : setProjectBudgetComment("");

        res.data.projectSchedule ? setProjectSchedule(res.data.projectSchedule) : setProjectSchedule("");
        res.data.projectScheduleComment ? setProjectScheduleComment(res.data.projectScheduleComment) : setProjectScheduleComment("");

        res.data.projectScope || res.data.projectScope === "" ? setProjectScope(res.data.projectScope) : setProjectScope("");
        res.data.projectScopeComment ? setProjectScopeComment(res.data.projectScopeComment) : setProjectScopeComment("");

        res.data.projectHumanResources ? setProjectHumanResources(res.data.projectHumanResources) : setProjectHumanResources("");
        res.data.projectHumanResourcesComment ? setProjectHumanResourcesComment(res.data.projectHumanResourcesComment) : setProjectHumanResourcesComment("");

        res.data.projectStakeholderEngagement ? setProjectStakeholderEngagement(res.data.projectStakeholderEngagement) : setProjectStakeholderEngagement("");
        res.data.projectStakeholderEngagementComment ? setProjectStakeholderEngagementComment(res.data.projectStakeholderEngagementComment) : setProjectStakeholderEngagementComment("");

        res.data.projectRisk ? setProjectRisk(res.data.projectRisk) : setProjectRisk("");
        res.data.projectRiskComment ? setProjectRiskComment(res.data.projectRiskComment) : setProjectRiskComment("");

        updateAllStatusColor(res);

      }
    });

  };

  const getProjectCodes = () => {
    Axios.get('https://updateprojectdetail.azurewebsites.net/api/getProjectCodes', {

    }).then((res, err) => {
      if (err)
        console.log(err)
      else {
        console.log("Retrieving project codes");
        setProjectCodes(res.data);
        console.log(projectCodes)
      }
    });
  };

  const clearAllField = () => {

    setProjectTitle("");
    setReportee("");
    setProjectOverall("");
    setProjectOverallComment("");
    setProjectBudget("");
    setProjectBudgetComment("");
    setProjectSchedule("")
    setProjectScheduleComment("")
    setProjectScope("")
    setProjectScopeComment("");
    setProjectHumanResources("")
    setProjectHumanResourcesComment("")
    setProjectStakeholderEngagement("")
    setProjectStakeholderEngagementComment("")
    setProjectRisk("")
    setProjectRiskComment("")
    updateAllStatusColor("");
  }

  useEffect(() => {
    getProjectCodes();
  }, [projectCode])

    ;

  return (
    <div className="App" >
      {/* {listItems} */}
      < h1 >
        Project Status report - Data Entry Form
      </h1 >
      <div>
        <div className="header">
          Project Details
        </div>
        <div className='form'>
          <table width="100%">
            <tr>
              <td>
                <label>
                  Project Code
                </label>
              </td>
              <td>

                <Autocomplete
                  id="free-solo-demo"
                  value={projectCode}
                  defaultValue=""
                  onChange={(e) => {
                    setProjectCode(e.target.innerText);
                  }}
                  disableClearable
                  getOptionDisabled={option => option ? selectState.disabled : true}
                  //disabled={state.disabled}
                  blurOnSelect="true"
                  options={Object.values(projectCodes).map((option) => option.projectCode)}
                  renderInput={(params) => (
                    <TextField {...params} label="Project Code" margin="normal" variant="outlined" />
                  )}
                />
              </td>
              <td><input
                type="submit"
                id="load"
                value="Load"

                onClick={() => {
                  console.log(document);
                  if (projectCode === "") {
                    setSelectState({ disabled: false });
                    alert("Enter a project Code")
                  }
                  else {
                    setSelectState({ disabled: true });
                    requestLatest();
                    document.getElementById('update').disabled = false;
                    document.getElementById('load').disabled = true;
                  }
                }} />
                <br />
                <input
                  type="submit"
                  id="update"
                  value="Reset"

                  onClick={() => {
                    clearAllField();
                    document.getElementById('load').disabled = false;
                    document.getElementById('free-solo-demo').disabled = false;
                    setProjectCode("");
                    setSelectState([{ disabled: false }]);
                  }} />
              </td>
              <td><label>Project Title </label></td>
              <td colSpan="2"><input
                type="text"
                className="longinput"
                name="projectTitle"
                value={projectTitle}
                defaultValue=""
                placeholder="Give your project a title"
                onChange={(e) => {
                  setProjectTitle(e.target.value)
                }}
              /></td>
            </tr>
            <tr>
              <td>Reported by</td>
              <td><input
                type="text"
                name="reportee"
                value={reportee}
                defaultValue=""
                placeholder="Name"
                onChange={(e) => {
                  setReportee(e.target.value)
                }}
              /></td>
              <td>Reporting Period</td>
              <td>
                <select
                  className="selectTraffic"
                  // id="projectSchedule"
                  disabled
                //value="August"
                //value={projectSchedule}
                // onChange={(e) => {
                //   setProjectSchedule(e.target.value)
                //   changeColor(e.target.value, e.target.id)
                // }}
                >
                  <option value="Month" hidden> Month </option>
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7" selected>July</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
                <select
                  disabled
                  className="selectTraffic"
                // id="projectSchedule"
                //value={projectSchedule}
                // onChange={(e) => {
                //   setProjectSchedule(e.target.value)
                //   //changeColor(e.target.value, e.target.id)
                // }}
                >
                  <option value="9999" hidden> Year </option>
                  <option value="2021" selected>2021</option>
                  <option value="2022">2022</option>
                </select></td>
              <td> Submission Timestamp</td>
              <td><input
                disabled
                type="text"
                name="reportDate"
                value={submittedDateTime}
                onLoad={(e) => {
                  setProjectCode(e.target.value)
                }}
              /></td>
            </tr>
          </table>
        </div>
      </div>

      {/* Create table form     */}
      <div>
        <div className="header">Project Status</div>
        <div className="form">
          <table>
            <tr>
              <th> </th>
              <th>Status </th>
              <th>Commentary </th>
            </tr>
            <tr>
              <td><label className="label">Overall</label></td>
              <td>
                <select
                  className="selectTraffic"
                  id="projectOverall"
                  value={projectOverall}
                  onChange={(e) => {
                    setProjectOverall(e.target.value)
                    changeColor(e.target.value, e.target.id)
                  }}>
                  <option className="selection" value="Select status"> Select Status: </option>
                  <option className="optionRed" value="red">Red</option>
                  <option className="optionAmber" value="orange">Amber</option>
                  <option className="optionGreen" value="green" >Green</option>
                </select></td>
              <td><textarea
                className="message"
                row="10"
                cols="50"
                value={projectOverallComment}
                onChange={(e) => {
                  setProjectOverallComment(e.target.value)
                }} />
              </td>
            </tr>
            <tr>
              <td><label className="label">Budget</label></td>
              <td><select
                className="selectTraffic"
                id="projectBudget"
                value={projectBudget}
                onChange={(e) => {
                  setProjectBudget(e.target.value)
                  changeColor(e.target.value, e.target.id)
                }}>
                <option value="Select status" defaultValue> Select Status: </option>
                <option className="optionRed" value="red">Red</option>
                <option className="optionAmber" value="orange">Amber</option>
                <option className="optionGreen" value="green" >Green</option>
              </select></td>
              <td><textarea
                className="message"
                row="10"
                cols="50"
                value={projectBudgetComment}
                onChange={(e) => {
                  setProjectBudgetComment(e.target.value)
                }} />
              </td>
            </tr>
            <tr>
              <td><label className="label">Schedule</label></td>
              <td><select
                className="selectTraffic"
                id="projectSchedule"
                value={projectSchedule}
                onChange={(e) => {
                  setProjectSchedule(e.target.value)
                  changeColor(e.target.value, e.target.id)
                }}>
                <option value="Select status" defaultValue> Select Status: </option>
                <option className="optionRed" value="red">Red</option>
                <option className="optionAmber" value="orange">Amber</option>
                <option className="optionGreen" value="green" >Green</option>
              </select></td>
              <td><textarea
                className="message"
                row="10"
                cols="50"
                value={projectScheduleComment}
                onChange={(e) => {
                  setProjectScheduleComment(e.target.value)
                }} />
              </td>
            </tr>
            <tr>
              <td><label className="label">Scope</label></td>
              <td><select
                className="selectTraffic"
                id="projectScope"
                value={projectScope}
                onChange={(e) => {
                  setProjectScope(e.target.value)
                  changeColor(e.target.value, e.target.id)
                }}>
                <option value="Select status" defaultValue> Select Status: </option>
                <option className="optionRed" value="red">Red</option>
                <option className="optionAmber" value="orange">Amber</option>
                <option className="optionGreen" value="green" >Green</option>
              </select></td>
              <td><textarea
                className="message"
                row="10"
                cols="50"
                value={projectScopeComment}
                onChange={(e) => {
                  setProjectScopeComment(e.target.value)
                }} />
              </td>
            </tr>
            <tr>
              <td><label className="label">Human <br /> Resources</label></td>
              <td><select
                className="selectTraffic"
                id="projectHumanResources"
                value={projectHumanResources}
                onChange={(e) => {
                  setProjectHumanResources(e.target.value)
                  changeColor(e.target.value, e.target.id)
                }}>
                <option value="Select status" defaultValue> Select Status: </option>
                <option className="optionRed" value="red">Red</option>
                <option className="optionAmber" value="orange">Amber</option>
                <option className="optionGreen" value="green" >Green</option>
              </select></td>
              <td><textarea
                className="message"
                row="10"
                cols="50"
                value={projectHumanResourcesComment}
                onChange={(e) => {
                  setProjectHumanResourcesComment(e.target.value)
                }} />
              </td>
            </tr>
            <tr>
              <td><label className="label">Stakeholder <br />Engagement</label></td>
              <td><select
                className="selectTraffic"
                id="projectStakeholderEngagement"
                value={projectStakeholderEngagement}
                onChange={(e) => {
                  setProjectStakeholderEngagement(e.target.value)
                  console.log("trigger")
                  changeColor(e.target.value, e.target.id)
                }}>
                <option value="Select status" defaultValue> Select Status: </option>
                <option className="optionRed" value="red">Red</option>
                <option className="optionAmber" value="orange">Amber</option>
                <option className="optionGreen" value="green" >Green</option>
              </select></td>
              <td>
                <textarea
                  className="message"
                  row="10"
                  cols="50"
                  value={projectStakeholderEngagementComment}
                  onChange={(e) => {
                    setProjectStakeholderEngagementComment(e.target.value)
                  }} />
              </td>
            </tr>
            <tr>
              <td><label className="label">Risks/Issues</label></td>
              <td><select
                className="selectTraffic"
                id="projectRisk"
                value={projectRisk}
                onChange={(e) => {
                  setProjectRisk(e.target.value)
                  changeColor(e.target.value, e.target.id)
                }}>
                <option value="Select status" defaultValue> Select Status: </option>
                <option className="optionRed" value="red">Red</option>
                <option className="optionAmber" value="orange">Amber</option>
                <option className="optionGreen" value="green" >Green</option>
              </select></td>
              <td>
                <textarea
                  className="message"
                  value={projectRiskComment}
                  onChange={(e) => {
                    setProjectRiskComment(e.target.value)
                  }} />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <input type="submit" value="Submit" id="submit" onClick={submitChange} />
    </div >
  );

}

export default App;
